import { Instagram } from 'lucide-react';

interface SocialLinksProps {
  /** Public Instagram profile URL. The icon is hidden when this is empty. */
  instagramUrl?: string | null;
  className?: string;
  /** Extra classes applied to each icon link (controls color/size). */
  linkClassName?: string;
}

/**
 * Renders configured social media icon links. Currently Instagram only —
 * driven entirely by the admin-configured profile URL, never hardcoded.
 */
export function SocialLinks({
  instagramUrl,
  className = '',
  linkClassName = '',
}: SocialLinksProps) {
  if (!instagramUrl) return null;

  return (
    <div className={`flex items-center gap-3 ${className}`}>
      <a
        href={instagramUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Follow us on Instagram"
        className={`inline-flex items-center justify-center transition-colors ${linkClassName}`}
      >
        <Instagram className="h-5 w-5" />
      </a>
    </div>
  );
}
